import { render } from "./UiDemo.html?vue&type=template&id=721b2eb5&scoped=true&external"
import script from "./UiDemo.ts?vue&type=script&lang=js&external"
export * from "./UiDemo.ts?vue&type=script&lang=js&external"

import "./UiDemo.scss?vue&type=style&index=0&id=721b2eb5&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721b2eb5"],['__file',"src/components/ui/UiDemo/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "721b2eb5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('721b2eb5', __exports__)) {
    api.reload('721b2eb5', __exports__)
  }
  
  module.hot.accept("./UiDemo.html?vue&type=template&id=721b2eb5&scoped=true&external", () => {
    api.rerender('721b2eb5', render)
  })

}


export default __exports__